// extracted by mini-css-extract-plugin
export default {"lastUpdatedDiv":"LastUpdated_lastUpdatedDiv__3c4OO","lastUpdatedLabel":"LastUpdated_lastUpdatedLabel__OSjAJ"};